<template>
  <div class="port_activity__row">
    <div v-if="item.action == 'create'">
      <div class="port_activity__date fz12">{{getDate(item.created_at)}}</div>
      <div class="port_activity__info">
        <div class="port_activity__user">{{item.user.first_name}} {{item.user.last_name}} </div>
        <div class="text-dark port_activity__type">
          created 
          <span class="text-dark" v-if="item.model == 'port'">{{ (port && port.data_type === 'canal') ? 'Canal' : 'Port'}}</span>
          <span class="text-dark" v-if="item.model == 'berth'">Berth</span>
          <span class="text-dark" v-if="item.model == 'portcontact'">Contact</span>
        </div>
      </div>
    </div>
    <div v-else v-for="change in item.changes" :key="change.id">
      <div class="port_activity__date fz12">{{getDate(item.created_at)}}</div>
      <div class="port_activity__info">
        <div class="port_activity__user">{{item.user.first_name}} {{item.user.last_name}} </div>
        <div class="port_activity__type">
          <span class="text-dark" v-if="change.field == 'is_archive'">{{change.changed_to == 'True' ? 'archived':'unarchived'}} the
            {{item.model == 'port' ? 'Port' : item.model == 'berth' ? 'Berth' : 'Contact'}}
          </span>

          <span class="text-dark" v-if="item.model == 'port' && change.field == 'name'"><span v-if="change.changed_to">changed the {{(port && port.data_type === 'canal') ? 'Canal' : 'Port'}} name to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the changed the {{(port && port.data_type === 'canal') ? 'Canal' : 'Port'}} name</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'country'"><span v-if="change.changed_to">changed the Country to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Country</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'max_draft'"><span v-if="change.changed_to">changed the Max Draft to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Max Draft</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'max_loa'"><span v-if="change.changed_to">changed the Max LOA to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Max LOA</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'max_beam'"><span v-if="change.changed_to">changed the Max Beam to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Max Beam</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'water_density'"><span v-if="change.changed_to">changed the Water Density to <i>"{{getWaterDensityName(change.changed_to)}}"</i></span><span v-else>deleted the Water Density</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'zone'"><span v-if="change.changed_to">changed the Zone to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Zone</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'weather_condition'"><span v-if="change.changed_to">changed the Weather Condition to <i>"{{change.changed_to}}"</i></span><span v-else>deleted the Weather Condition</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'latitude'"><span v-if="change.changed_to">changed the Position Latitude to <i>"{{change.changed_to}} N"</i></span><span v-else>deleted the Position Latitude</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'longitude'"><span v-if="change.changed_to">changed the Position Longitude to <i>"{{change.changed_to}} E"</i></span><span v-else>deleted the Position Longitude</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'files'" v-html="getInfoFromFiles(change)"></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'pda'" v-html="getInfoFromPda(change)"></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'transit_time'"><span v-if="change.changed_to">changed the Transit Time to <i>"{{ change.changed_to }}"</i></span><span v-else>deleted the Transit Time</span></span>
          <span class="text-dark" v-if="item.model == 'port' && change.field == 'dwt_fields'"><span v-if="change.changed_to.length" v-html="getTextDwtChanged(change.changed_from, change.changed_to)"></span></span>
          <span class="text-dark" v-if="change.field == 'min'"><span v-if="change.changed_to">changed the <b>DWT</b> field <b>Min</b> to <i> "{{ change.changed_to | formatNumberTwo}}"</i></span><span v-else>deleted the <b>DWT</b> field <b>Min</b></span></span>
          <span class="text-dark" v-if="change.field == 'max'"><span v-if="change.changed_to">changed the <b>DWT</b> field <b>Max</b> to <i> "{{ change.changed_to | formatNumberTwo}}"</i></span><span v-else>deleted the <b>DWT</b> field <b>Max</b></span></span>
          <span class="text-dark" v-if="change.field == 'price'"><span v-if="change.changed_to">changed the <b>DWT</b> field <b>Price</b> to <i> "{{ change.changed_to | formatNumberTwo}}"</i></span><span v-else>deleted the <b>DWT</b> field <b>Price</b></span></span>

          <span class="text-dark" v-if="item.model == 'port' &&
            (change.field == 'bunkerning_in_transit' ||
            change.field == 'bunkerning_at_berth' ||
            change.field == 'bunkerning_at_road' ||
            change.field == 'bunkerning_not_available')
          ">changed Bunkering</span>

          <!-- BERTHS -->
          <span class="text-dark" v-if="item.model == 'berth' && change.field != 'is_archive'">changed Berth</span>
          <!-- CONTACTS -->
          <span class="text-dark" v-if="item.model == 'portcontact' && change.field != 'is_archive'">changed Contact</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  props: {
    item: Object
  },
  data() {
    return {
      allowTypes: [
        'tif', 
        'tiff', 
        'bmp', 
        'jpg', 
        'jpeg', 
        'gif', 
        'png'
      ]
    }
  },
  computed: {
    ...mapState({
      waterDensityList: state => state.ports.waterDensityList,
      port: state => state.ports.openPort

    }),
  },
  methods: {
    getTextDwtChanged(from, to) {
      let text = ''
      if(Array.isArray(from) === true && Array.isArray(to) === true) {
        if(from.length>to.length) {
          // let IDs = to.map(a=>{return a.id})
          text = 'deleted the <b>DWT'
          // from.forEach((item, i)=> {
          //   if(IDs.indexOf(item.id) === -1) {
          //     text+=' #'+(i+1)
          //   }
          // })
          text+='</b> '
        }
        if(from.length<to.length) {
          // let IDs = from.map(a=>{return a.id})
          text = 'added the <b>DWT'
          // to.forEach((item, i)=> {
          //   if(IDs.indexOf(item.id) === -1) {
          //     text+=' #'+(i+1)
          //   }
          // })
          text+='</b> '
        }
        to.forEach((item)=> {
          let findItem = from.find(a=> a.id === item.id);
          if(findItem) {
            if(findItem.min !== item.min || findItem.max !== item.max || findItem.price !== item.price) {
              text = ' changed the <b>DWT ' + '</b> field '
              if(findItem.min !== item.min) {
                text+= ' <b>Min</b> to <i>'+item.min+'</i>'
              }
              if(findItem.max !== item.max) {
                text+= ' <b>Max</b> to <i>'+item.max+'</i>'
              }
              if(findItem.price !== item.min) {
                text+= ' <b>Price</b> to <i>'+item.price+'</i>'
              }
            }
          }
        })
        text+='</i> '
      } else {
            return 'deleted the <b>DWT<b>'
      }


      return text
    },
    isFileImg(file){
      // console.log('lol2', file);
      if(file) {
        let dotIndex = (file).lastIndexOf('.')
        let fileType = file.slice(dotIndex+1, file.length)
        let typeIndex = this.allowTypes.indexOf(fileType)
        return typeIndex >= 0 ? true : false
      }
      return false
    },
    getDate(date) {
      return moment(date).utcOffset(6).format('DD MMM YYYY, HH:mm')
    },
    getInfoFromFiles(change) {
      let resultStr = ''

      if(change.changed_to.length == '0'){
        let fileName = change.changed_from[0].name ? change.changed_from[0].name : change.changed_from[0].file
        resultStr = 'removed a file ' + (fileName ? ' <i>"' + fileName + '"</i>' : '')
        return resultStr
      }
      if(change.changed_from.length == '0'){
        let fileName = change.changed_to[0].name ? change.changed_to[0].name : change.changed_to[0].file
        let img = this.isFileImg(change.changed_to[0].file) ? `<img src="${process.env.VUE_APP_URL}/media/${change.changed_to[0].file}" alt="${fileName}"/>` : `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 48H41C42.6569 48 44 46.6569 44 45V13L31 0H7C5.34315 0 4 1.34315 4 3V45C4 46.6569 5.34315 48 7 48Z" fill="#DEE3EA"/><path d="M16.9506 31.6148L23.4913 12V28.2712C23.4913 28.5016 23.3571 28.7106 23.1485 28.8052L16.9506 31.6148Z" fill="#9AA3B0"/><path d="M31.0494 31.6148L24.5087 12V28.2712C24.5087 28.5016 24.6429 28.7106 24.8515 28.8052L31.0494 31.6148Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.6601 17.2724C16.789 17.942 12.2267 22.9613 12.2267 29.0532C12.2267 31.1083 12.7456 33.0403 13.6584 34.7247L23.2353 30.1223V30.9274L13.3621 35.6754L13.1942 35.3854C12.117 33.525 11.5 31.3611 11.5 29.0532C11.5 22.5847 16.344 17.2562 22.5783 16.5451L22.6601 17.2724ZM35.7733 29.0532C35.7733 22.9613 31.211 17.942 25.3399 17.2724L25.4217 16.5451C31.656 17.2562 36.5 22.5847 36.5 29.0532C36.5 31.3611 35.883 33.525 34.8058 35.3854L34.6359 35.6788L24.7647 30.9412L24.7544 30.1223L34.3435 34.7212C35.2551 33.0376 35.7733 31.1068 35.7733 29.0532Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 33.5294L14.963 37.5732L14.6471 36.9141L23.2353 32.7059V33.5294Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 35.8823L16.6619 39.1399L16.3478 38.4798L23.2353 35.0772V35.8823Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 38.2243L18.2608 40.75L17.9466 40.09L23.2353 37.4192V38.2243Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 33.5294L33.2674 37.5292L33.5833 36.8701L24.7647 32.7059V33.5294Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 35.8823L31.7422 39.1399L32.0562 38.4798L24.7647 35.0772V35.8823Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 38.2243L30.1433 40.75L30.4574 40.09L24.7647 37.4192V38.2243Z" fill="#9AA3B0"/><path d="M44 13L34 13C32.3431 13 31 11.6569 31 10L31 -1.82822e-07L36.881 5.98L44 13Z" fill="#BDCBD6"/></svg>`
        resultStr = `attached a file `+ (fileName ? ` <i>"${fileName}"</i>` : ``) + `${img}`
        return resultStr
      }

      if(change.changed_from.length > change.changed_to.length){ //remove file
        
        for (let i = 0; i < change.changed_from.length; i++) {
          const el = change.changed_from[i]

          if(change.changed_to[i] || el.id != change.changed_to[i].id){
            let fileName = el.name ? el.name : el.file
            resultStr = 'removed a file '+ (fileName ? ' <i>"' + fileName + '"</i>' : '')
            break
          }
        }
      } else if(change.changed_from.length < change.changed_to.length){ // attach file
        for (let i = 0; i < change.changed_to.length; i++) {
          const el = change.changed_to[i]
          if(!change.changed_from[i] || el.id != change.changed_from[i].id){
            let fileName = el.name ? el.name : el.file
            let img = this.isFileImg(el.file) ? `<img src="${process.env.VUE_APP_URL}/media/${el.file}" alt="${fileName}"/>` : `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 48H41C42.6569 48 44 46.6569 44 45V13L31 0H7C5.34315 0 4 1.34315 4 3V45C4 46.6569 5.34315 48 7 48Z" fill="#DEE3EA"/><path d="M16.9506 31.6148L23.4913 12V28.2712C23.4913 28.5016 23.3571 28.7106 23.1485 28.8052L16.9506 31.6148Z" fill="#9AA3B0"/><path d="M31.0494 31.6148L24.5087 12V28.2712C24.5087 28.5016 24.6429 28.7106 24.8515 28.8052L31.0494 31.6148Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M22.6601 17.2724C16.789 17.942 12.2267 22.9613 12.2267 29.0532C12.2267 31.1083 12.7456 33.0403 13.6584 34.7247L23.2353 30.1223V30.9274L13.3621 35.6754L13.1942 35.3854C12.117 33.525 11.5 31.3611 11.5 29.0532C11.5 22.5847 16.344 17.2562 22.5783 16.5451L22.6601 17.2724ZM35.7733 29.0532C35.7733 22.9613 31.211 17.942 25.3399 17.2724L25.4217 16.5451C31.656 17.2562 36.5 22.5847 36.5 29.0532C36.5 31.3611 35.883 33.525 34.8058 35.3854L34.6359 35.6788L24.7647 30.9412L24.7544 30.1223L34.3435 34.7212C35.2551 33.0376 35.7733 31.1068 35.7733 29.0532Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 33.5294L14.963 37.5732L14.6471 36.9141L23.2353 32.7059V33.5294Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 35.8823L16.6619 39.1399L16.3478 38.4798L23.2353 35.0772V35.8823Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23.2353 38.2243L18.2608 40.75L17.9466 40.09L23.2353 37.4192V38.2243Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 33.5294L33.2674 37.5292L33.5833 36.8701L24.7647 32.7059V33.5294Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 35.8823L31.7422 39.1399L32.0562 38.4798L24.7647 35.0772V35.8823Z" fill="#9AA3B0"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24.7647 38.2243L30.1433 40.75L30.4574 40.09L24.7647 37.4192V38.2243Z" fill="#9AA3B0"/><path d="M44 13L34 13C32.3431 13 31 11.6569 31 10L31 -1.82822e-07L36.881 5.98L44 13Z" fill="#BDCBD6"/></svg>`
            resultStr = `attached a file `+ (fileName ? ` <i>"${fileName}"</i>` : ``) + `${img}`
            break
          }
        }
      }else{
        resultStr = 'unknown change in files'
      }
      return resultStr
    },
    getInfoFromPda(change) {
      let resultStr = ''

      if(change.changed_to.length == '0'){
        resultStr = 'deleted pda'
        return resultStr
      }
      if(change.changed_from.length == '0'){
        resultStr = 'added pda'
        return resultStr
      }

      if(change.changed_from.length > change.changed_to.length){ //remove pda
        
        for (let i = 0; i < change.changed_from.length; i++) {
          const el = change.changed_from[i]

          if(el.id != change.changed_to[i].id){
            resultStr = 'deleted pda'
            break
          }
        }
      }else if(change.changed_from.length < change.changed_to.length){ // attach pda
        for (let i = 0; i < change.changed_to.length; i++) {
          const el = change.changed_to[i]
          if(!change.changed_from[i] || el.id != change.changed_from[i].id){
            resultStr = 'add pda'
            break
          }
        }
      }else{
        resultStr = 'unknown change in PD/A'
      }
      return resultStr
    },
    getWaterDensityName(id) {
      return this.waterDensityList.filter(el => {
        return el.id == id
      })[0].name
    }
  }
}
</script>

<style lang="scss">
  b {
    font-weight: 700;
  }
</style>